<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>RAPOR KAYIT EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">RAPOR KAYIT EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">RAPOR KAYIT EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label">Rapor Girilecek Sahayı Seçiniz</label>
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>SAHA SEÇİNİZ</option>
                    <option v-for="saha in sahalar" :value="saha.id" :key="saha.id">{{ saha.id }} - {{ saha.sahaName }}</option>
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">Makina Seçiniz</label>
                  <select class="form-control" @change="changemakina($event)">
                    <option value="" selected disabled>MAKİNA SEÇİNİZ</option>
                    <option v-for="machine in machines" :value="machine.id" :key="machine.id">{{
                    machine.makina_code + " " + machine.makina_name
                  }}</option>
                  </select>
                  <label class="control-label">Delgi Kategorisini Seçiniz</label>
                  <select class="form-control" @change="changecategory($event)">
                    <option value="" selected disabled>KATEGORİ SEÇİNİZ</option>
                    <option v-for="category in category" :value="category.id" :key="category.id">{{
                    category.delgicategoryname
                  }}</option>
                  </select>

                </div>
                <div class="form-group">
                  <label class="control-label">Personel Adı</label>
                  <select class="form-control" @change="changeoperator($event)">
                    <option value="" selected disabled>Personel Seçiniz</option>
                    <option v-for="personel in personeller" :value="personel.id" :key="personel.id">{{ personel.name }}
                      {{ personel.surname }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="control-label">Yapılan Delgi Sayısı</label>
                  <input v-model="delgisayisi" class="form-control" type="number" placeholder="Yapılan Delgi Sayısı" />
                </div>
                <div class="form-group">
                  <label class="control-label">Delgi Tarihi</label>
                  <br />
                  <input v-model="delgitarihi" type="date" />
                </div>
                <div class="form-group">
                  <label class="control-label">Motor Başlama</label>
                  <input v-model="motorbaslama" class="form-control" type="number" placeholder="Motor Başlama" />
                </div>
                <div class="form-group">
                  <label class="control-label">Motor Bitiş</label>
                  <input v-model="motorbitis" class="form-control" type="number" placeholder="Motor Bitiş" />
                </div>
                <div class="form-group">
                  <label class="control-label">Açıklama</label>
                  <input v-model="aciklamaone" class="form-control" type="text" placeholder="Açıklama" />
                </div>
                <div class="form-group">
                  <label class="control-label">Açıklama 2</label>
                  <input v-model="aciklamatwo" class="form-control" type="text" placeholder="Açıklama 2" />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahaname: "",
      sahalar: [],
      delgisayisi: "",
      delgitarihi: "",
      motorbaslama: "",
      motorbitis: "",
      aciklamaone: "",
      aciklamatwo: "",
      machines: [],
      category: [],
      personeller: [],
      makinaId: "",
      operatorid: "",
      categoryId: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.sahalar = response.data;
        //console.log(sahalar);
      })
      .catch((err) => {
        console.log(err.response);
      });

    var url3 = store.state.base_url + "AslanSahalar/getAllPersonelStatus.php?key=123";
    axios
      .post(url3)
      .then((response3) => {
        this.personeller = response3.data;
        //     console.log(response3.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllDelgiCategories.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.category = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });

  },
  methods: {
    changemakina(event) {
      this.makinaId = event.target.value;
    },
    changeoperator(event) {
      this.operatorid = event.target.value;
    },
    changecategory(event) {
      this.categoryId = event.target.value;
      console.log(event.target.value);
    },
    getBySaha(event) {
      var saha_id = event.target.value;
      this.saha_id = saha_id;
      var url = store.state.base_url + "AslanSahalar/getByIdSaha.php?key=123";
      var datas = { saha_id };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          var veri = response.data.data[0];
          this.cap_delgi = veri.cap_delgi;
          this.derinlik = veri.derinlik;
          this.fiyat_delgi = veri.fiyat_delgi;
          this.toplam_delgi = veri.toplam_delgi;
        })
        .catch((err) => {
          console.log(err.response);
        });
      var urlm = store.state.base_url + "AslanSahalar/getAllMakinaSaha.php?key=123";
      axios
      .post(urlm, JSON.stringify(datas))
        .then((response) => {
          this.machines = response.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    reload: function () {
      location.reload();
    },
    sendData: function () {
      console.log(this.oprone);
      if (this.delgisayisi == "") {
        this.$swal({
          text: "DELGİ SAYISINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.motorbaslama == "") {
        this.$swal({
          text: "MOTOR SAATİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.motorbitis == "") {
        this.$swal({
          text: "MOTOR BİTİŞ SAATİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.categoryId == "") {
        this.$swal({
          text: "DELGİ KATEGORİSİ SEÇİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.delgitarihi == "") {
        this.$swal({
          text: "DELGİ TARİHİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.operatorid == "") {
        this.$swal({
          text: "OPERATÖR SEÇİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        var url =
          store.state.base_url + "AslanSahalar/updateSahaDelgi.php?key=123";
        var datas = {
          categoryId: this.categoryId - 1,
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          delgisayisi: this.delgisayisi,
          delgitarihi: this.delgitarihi,
          motorbaslama: this.motorbaslama,
          motorbitis: this.motorbitis,
          aciklamaone: this.aciklamaone,
          aciklamatwo: this.aciklamatwo,
          makinaId: this.makinaId,
          saha_id: this.saha_id,
          operatorid: this.operatorid,
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data.data == true) {
              this.$swal({
                text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              // setTimeout(function() {
              //   location.reload();
              // }, 1250);
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RaporKayit.vue